const parseAustralianNumberToInternational = (number: string): string => {
  if (number.startsWith("+61")) return number;

  const parsedNumber = number.substring(1);

  return `+61${parsedNumber}`;
};

export default parseAustralianNumberToInternational;
